import { render } from "./EmailListItem.vue?vue&type=template&id=0566af8c&scoped=true&ts=true"
import script from "./EmailListItem.vue?vue&type=script&lang=ts"
export * from "./EmailListItem.vue?vue&type=script&lang=ts"

import "./EmailListItem.vue?vue&type=style&index=0&id=0566af8c&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Finity\\Pulse\\Frontend\\Cedita.Pulse.Web.Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0566af8c"]])

export default __exports__